import getSelectedTableView from "./getSelectedTableView";
import { owaComputedFn } from "owa-computed-fn";

const getComputedIsInVirtualSelectAllMode: () => boolean = owaComputedFn(function getComputedIsInVirtualSelectAllMode(): boolean {
    return getSelectedTableView()?.isInVirtualSelectAllMode ?? false;
});
export default getComputedIsInVirtualSelectAllMode;
